import { rem } from 'polished';
import React from 'react';
import styled from 'styled-components';

import { Text } from '@vimeo/bokeh';
import { Bell } from '@vimeo/bokeh-icons';
import { translate } from '@vimeo/i18n-runtime';

const Wrapper = styled.div`
  font-size: ${rem(14)};
  line-height: ${rem(20)};
  text-align: center;
`;

const ActivityEmptyState = () => (
  <Wrapper>
    <Bell boxSize="3.75rem" mb={rem(12)} color="slate.200" />
    <Text variant="heading-xs" mb={rem(7)}>
      {translate('No activity in the past 30 days')}
    </Text>
    <Text variant="body-md" color="text-secondary" _dark={{ color: 'text-secondary' }}>
      {translate("We'll alert you once something cool happens.")}
    </Text>
  </Wrapper>
);

export default ActivityEmptyState;
